import React from 'react';
import './hero.scss';
import pfizerLogo from '../../assets/pfizer-logo.svg';

const Hero = () => {
  return (
    <div className="hero">
      <div className="hero__logo">
        <img src={pfizerLogo} alt="pfizer logo" />
      </div>
      <div className="hero__texts">
        <h1>The Cycle of Itch: Eczema’s Physical and Emotional Toll</h1>
        <h5>
          The emotional impact of this skin condition can be just as difficult as the physical.
        </h5>
      </div>
    </div>
  );
};

export default Hero;
